<template>
  <div data-component-group="filter-forms" data-component="package">
    <FiltersForm
      :has-filters="hasFilters"
      :is-global-country-filter="false"
      @filter="onFilter"
      @clear="onClearFilters"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import stringEscape from 'js-string-escape';
  import FiltersForm from './FiltersBase';
  import { isNull } from '@/utils'

  // TODO: Translate component

  export default {
    components: {
      FiltersForm,
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        search: '',
      };
    },
    computed: {
      hasFilters() {
        const { search } = this;

        return search !== '';
      },
    },
    methods: {
      onFilter() {
        const { search } = this;
        const formattedSearch = isNull(search) ? '' : stringEscape(search);

        this.$emit('filter', {
          search: formattedSearch,
        });
      },
      onClearFilters() {
        this.search = '';

        this.$emit('clearFilters');
      },
    },
  };
</script>
